/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_DisplayInputs */

const vi_shop_group_display = /** @type {(inputs: Shop_Group_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiển thị`)
};

/**

* @param {Shop_Group_DisplayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_display = /** @type {((inputs?: Shop_Group_DisplayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_DisplayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_display(inputs)
});